import React, { useContext, useEffect, useState } from 'react';
import { Button, Card, Col, Form, InputGroup, Row, Spinner } from 'react-bootstrap';
import MaskedInput from 'react-text-mask';

import { useForm } from '../../../hooks/useForm';
import { fetchConToken } from '../../../api/fetch';
import { AuthContext } from '../../../auth/AuthContext';
import { useContextInfo } from '../../../context/ContextInfo';
import { UserContext } from '../../../context/user/ContextUser';
import { RedContext } from '../../../context/connection/ContextRed';
import MapaRender from '../../map/MapaRender';
import LoadinSpin from '../../ui/LoadinSpin';
import { checkAccess } from '../../../helpers/details';

const EditarFibra = ({ fibra, service, callBk }) => {
    const { auth } = useContext(AuthContext);
    const { roll } = auth;
    const permisos = checkAccess('Servicios', auth.accesos);
       const {srv_editar, srv_editar_full } = permisos.functions
    const { port_nap = 0 } = fibra;
    const [firewall_state, setfirewall_state] = useState(service.firewall_state);
    const { setResp } = useContextInfo();
    const { usersState } = useContext(UserContext);
    const [showMp, setshoMp] = useState(false);
    const [validated, setValidated] = useState(false);
    const [load, setLoad] = useState(false);
    const { redState } = useContext(RedContext);
    const [mkRedes, setRedesMk] = useState([]);
    const [ipRed, setIpRed] = useState([]);
    const [Ports, setPuertos] = useState([]);
    const [naps, setNap] = useState([]);
    const [onus, setOnus] = useState([]);
    const [loader, setLoader] = useState(true);

    const [coords, setCoord] = useState([]);

    const [values, handleInputChange, setFormValue] = useForm({
        mknodo: service.mknodo,
        olt: fibra.id_olt,
        ser_tipo: 'FIBRA',
        redIpv4: service.redIpv4,
        idIpv4: service.idIpv4,
        ip: service.ip,
        mac: service.mac,
        id_tec: service.id_tec,

        coordenadas: service.coordenadas,
        idperfil: fibra.id_speed,
        idnap: fibra.id_nap,
        portnap: fibra.port_nap,
    });
    const { mknodo, redIpv4, idnap, olt, idperfil } = values;
    useEffect(() => {
        setLoader(true);
        setFormValue({
            mknodo: service.mknodo,
            olt: fibra.id_olt,
            ser_tipo: 'FIBRA',
            redIpv4: service.redIpv4,
            idIpv4: service.idIpv4,
            ip: service.ip,
            mac: service.mac,
            id_tec: service.id_tec,

            coordenadas: service.coordenadas,
            idperfil: fibra.id_speed,
            idnap: fibra.id_nap,
            portnap: fibra.port_nap,
        });
        setfirewall_state(service.firewall_state);
        setTimeout(() => {
            setLoader(false);
        }, 2000);
    }, [service]);
 
    useEffect(() => {
        getIpv4();
    }, [mknodo]);
    useEffect(() => {
        getIp();
    }, [redIpv4]);
    useEffect(() => {
        getNaps();
    }, []);
    useEffect(() => {
        getPort();
    }, [idnap]);

    useEffect(() => {
        passCoords();
    }, [values.coordenadas]);
    // !obtine los puertos del nap
    const getPort = async () => {
        const id = parseInt(idnap);
        if (id) {
            const res = await fetchConToken(`networks/napports/${id}/${port_nap}`);
            if (res.ok) {
                setPuertos(res.data);
            }
        } else {
            setPuertos([]);
        }
    };

    //!obtine los ipv4 redes qu epertenecen al mktik
    const getIpv4 = async () => {
        if (mknodo) {
            const re = await fetchConToken(`networks/ipv4bymkt/${mknodo}`);
            if (re.ok) setRedesMk(re.data);
        } else {
            setIpRed([]);
            setRedesMk([]);
            setFormValue({ ...values, ip: '' });
        }
    };
    // !obtiene las ips del ipv4 red
    const getIp = async () => {
        if (redIpv4.length) {
            const res = await fetchConToken(`servis/ip/${values.redIpv4}/${service.ip}`);
            if (res.ok) {
                setIpRed(res.data);
                if (values.redIpv4 === service.redIpv4) {
                    setFormValue({ ...values, ip: service.ip });
                } else {
                    setFormValue({ ...values, ip: res.data[0] });
                }
            }
        } else {
            setIpRed([]);
            setFormValue({ ...values, ip: '' });
        }
    };
    const getNaps = async () => {
        const resu = await fetchConToken(`networks/naps/`);
        if (resu.ok) {
            setNap(resu.data.naps);
            setOnus(resu.data.onus);
        }
    };
    const changeCoor = (coords) => {
        setFormValue({ ...values, coordenadas: coords });
    };
    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        if (load) return;
        setLoad(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            const result = mkRedes.find((red) => red.subred === redIpv4);

            const data = {
                mknodo: values.mknodo,
                ser_tipo: values.ser_tipo,
                firewall_state,
                redIpv4: values.redIpv4,
                idIpv4: result?.id,
                ip: values.ip,
                mac: values.mac,
                id_tec: values.id_tec,

                coordenadas: values.coordenadas,
                instalado: values.instalado,
            };
            const fibra = {
                id_speed: values.idperfil,
                id_olt: values.olt,
                id_nap: values.idnap,
                port_nap: values.portnap,
            };
            const res = await fetchConToken(
                `user/service/${service.id}`,
                {
                    service: data,
                    type: fibra,
                },
                'PUT'
            );
            setResp(res);
            if (res.ok) callBk();
        }
        setLoad(false);
    };
    const passCoords = () => {
        if (values.coordenadas?.length > 0) {
            const arr = values?.coordenadas.split(',');
            if (arr.length > 1) {
                setCoord([{ lat: parseFloat(arr[0]), lng: parseFloat(arr[1]) }]);
            }
        }
    };
    if (loader) return <LoadinSpin />;
    return (
        <div>
            {' '}
            <>
                <Row>
                    <Col>
                        <Form noValidate validated={validated} onSubmit={onSubmit}>
                            <Row>
                                <Col>
                                    <Col>
                                        {' '}
                                        <Form.Group className="mb-3" controlId="validationCustom0">
                                            <Form.Label>Router</Form.Label>
                                            <Form.Select
                                                value={values.mknodo}
                                                name="mknodo"
                                                required
                                                disabled={!srv_editar_full}
                                                onChange={handleInputChange}>
                                                <option value="">Selecciona un Router </option>

                                                {redState.mktiks.map((mk, i) => (
                                                    <option value={mk.id} key={i + 'n'}>
                                                        {mk.nodo}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        {' '}
                                        <Form.Group className="mb-3" controlId="validationCustom0">
                                            <Form.Label>Olt</Form.Label>
                                            <Form.Select
                                                value={values.olt}
                                                name="olt"
                                                required
                                                disabled={!srv_editar_full}

                                                onChange={handleInputChange}>
                                                <option value="">Selecciona una olt </option>

                                                {redState.olts.map((mk, i) => (
                                                    <option value={mk.id} key={i + 'p'}>
                                                        {mk.nombre}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        {' '}
                                        <Form.Group className="mb-3" controlId="validationCustom0">
                                            <Form.Label> Plan de internet</Form.Label>
                                            <Form.Select
                                                value={values.idperfil}
                                                name="idperfil"
                                                required
                                                disabled={!srv_editar_full}
                                                onChange={handleInputChange}>
                                                <option value="">Selecciona un plan </option>
                                                {redState.planesfi.map((int, i) => {
                                                    if (!int.disabled) {
                                                        return (
                                                            <option value={int.id} key={i}>
                                                                {int.nombre}
                                                            </option>
                                                        );
                                                    }
                                                    if (int.id === values.idperfil) {
                                                        return (
                                                            <option value={int.id} key={i + 'p'}>
                                                                {int.nombre}
                                                            </option>
                                                        );
                                                    }
                                                    return null;
                                                })}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        {' '}
                                        <Form.Group className="mb-3" controlId="validationCustom0">
                                            <Form.Label> Redes IPv4</Form.Label>
                                            <Form.Select
                                                value={values.redIpv4}
                                                name="redIpv4"
                                                required
                                                disabled={!srv_editar_full}
                                                onChange={handleInputChange}>
                                                <option value="">Seleccionar... </option>

                                                {mkRedes.map((iv) => (
                                                    <option value={iv.subred} key={iv.subred + 'sub'}>
                                                        {iv.subred} ( {iv.host - iv.us} Ips disponibles) {iv.nombre}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        {' '}
                                        <Form.Group className="mb-3" controlId="validationCustom0">
                                            <Form.Label> IPv4</Form.Label>
                                            <Form.Select
                                                value={values.ip}
                                                name="ip"
                                                disabled={!srv_editar_full}
                                                onChange={handleInputChange}>
                                                <option value="">Selecciona una red </option>
                                                {ipRed.map((ip, i) => (
                                                    <option value={ip} key={i + 'ip'}>
                                                        {ip}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3" controlId="validationCustom1">
                                            <Form.Label>Mac</Form.Label>
                                            <MaskedInput
                                                mask={[
                                                    /[A-Fa-f0-9]/,
                                                    /[A-Fa-f0-9]/,
                                                    ':',
                                                    /[A-Fa-f0-9]/,
                                                    /[A-Fa-f0-9]/,
                                                    ':',
                                                    /[A-Fa-f0-9]/,
                                                    /[A-Fa-f0-9]/,
                                                    ':',
                                                    /[A-Fa-f0-9]/,
                                                    /[A-Fa-f0-9]/,
                                                    ':',
                                                    /[A-Fa-f0-9]/,
                                                    /[A-Fa-f0-9]/,
                                                    ':',
                                                    /[A-Fa-f0-9]/,
                                                    /[A-Fa-f0-9]/,
                                                ]}
                                                required
                                                disabled={!srv_editar_full}
                                                type="text"
                                                className="form-control text-uppercase"
                                                name="mac"
                                                onChange={handleInputChange}
                                                value={values.mac}
                                            />
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                    </Col>
                                </Col>
                                <Col>
                                    <Col>
                                        {' '}
                                        <Form.Group className="mb-3" controlId="validationCustom0">
                                            <Form.Label> Técnico</Form.Label>
                                            <Form.Select
                                                value={values.id_tec}
                                                name="id_tec"
                                                required
                                                disabled={!srv_editar_full}
                                                onChange={handleInputChange}>
                                                <option value="0">Sin asignar </option>

                                                {usersState?.agentes
                                                    .filter(({ campo }) => campo === true)
                                                    .map(({ id_agent, name }) => (
                                                        <option value={id_agent} key={id_agent + 'ag'}>
                                                            {name}
                                                        </option>
                                                    ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        {' '}
                                        <Form.Group className="mb-3" controlId="validationCustom0">
                                            <Form.Label>Caja NAp</Form.Label>
                                            <Form.Select
                                                value={values.idnap}
                                                name="idnap"
                                                required
                                                disabled={!srv_editar_full}
                                                onChange={handleInputChange}>
                                                <option value="">Ninguno </option>

                                                {naps
                                                    .filter(({ id_olt }) => id_olt === parseInt(values.olt))
                                                    .map((na) => (
                                                        <option value={na.id} key={na.id + 'ns'}>
                                                            {na.descripcion} {`(`}
                                                            {na.puertos - na.used}
                                                            {`)`} disponibles
                                                        </option>
                                                    ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Row>
                                            <Col>
                                                {' '}
                                                <Form.Group className="mb-3" controlId="validationCustom0">
                                                    <Form.Label> Puerto Nap</Form.Label>
                                                    <Form.Select
                                                        disabled={!srv_editar_full}
                                                        value={values.portnap}
                                                        name="portnap"
                                                        required
                                                        onChange={handleInputChange}>
                                                        <option value="">Ninguno </option>
                                                        {Ports.map((na) => (
                                                            <option value={na} key={na + 'ui'}>
                                                                Puerto {na}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </Row>{' '}
                                    </Col>
                                    <Col>
                                        {' '}
                                        <Form.Group className="mb-3" controlId="validationCustom08">
                                            <Form.Label>Coordenadas</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text
                                                    id="inputGroupPrepend"
                                                    onClick={() => setshoMp(!showMp)}>
                                                    <i className="mdi mdi-map-marker-radius" />
                                                </InputGroup.Text>
                                                <Form.Control
                                                     disabled={!srv_editar}
                                                    type="text"
                                                    value={values.coordenadas}
                                                    name="coordenadas"
                                                    onChange={handleInputChange}
                                                />
                                            </InputGroup>
                                        </Form.Group>{' '}
                                    </Col>{' '}
                                    <Col>
                                        {' '}
                                        <Form.Group className="mb-3" controlId="validationCustom0999">
                                            <Form.Check
                                                disabled={!srv_editar_full}
                                                checked={firewall_state}
                                                onChange={() => setfirewall_state(!firewall_state)}
                                                type="switch"
                                                label="Excluir firewall"
                                                className="mt-1"
                                            />{' '}
                                        </Form.Group>
                                    </Col>
                                </Col>
                            </Row>{' '}
                            {load ? (
                                <Button color="primary" disabled>
                                    <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                    Guardando...
                                </Button>
                            ) : (
                                <Button type="submit">Guardar</Button>
                            )}
                        </Form>
                    </Col>
                </Row>
            </>
            <MapaRender
                show={showMp}
                onClose={() => setshoMp(false)}
                legend="Emisor"
                marks={coords}
                setCoor={changeCoor}
            />
        </div>
    );
};

export default EditarFibra;
